export default __webpack_public_path__ + "static/media/favicon.dbe9d521.ico";